import React, { Component } from "react";
import { Link } from "react-router-dom";
import TextField from "../component/TextField";
import FpgDisableIcon from "../icons/fpgdisableicon";
import FpgpublishIcon from "../icons/fpgpublishicon";
import checkmarkicon from '../assets/images/checkmark_icon.svg';
import checkmarkiconGreen from '../assets/images/checkmark_icon_green.svg';
import Barcode from '../assets/images/barcode.svg';
import PlusIcon from "../icons/plusicon";
import PopUpCustomAll from "../component/fpg/create/popUpCustomAll";
import Loader from "../component/loader";
//Service import
import service from "../services";
//Validation import
import SimpleReactValidator from "simple-react-validator";

// Editors
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import WaitlistRefreshIcon from '../icons/WaitlistRefreshIcon'
//Redux Connect
import { connect } from "react-redux";
import moment from "moment";
import TextEditor from "../component/TextEditor";
import ErrorPopUp from "../component/errorPopUp";
import WailtListQRCode from "./WailtListQRCode";
import { WAITLIST_STATUS } from "../cosntants";

let sub;
const items = Array.from({ length: 20 }, (_, index) => index + 1);

const mapStateToProps = (state) => ({
  EmailListEditId: state.EmailListEditId,
});

// const mapDispatchToProps = (dispatch) => {
//   return bindActionCreators(ActCreators, dispatch);
// };
class WaitlistListDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loaderFlag: false,
      name: "",
      price: "",
      changeCategoryTitleName: false,
      isClicked: false,
      isWaitlistPopupOpen: false,
      passId:'',
      waitListReservations:[],
      title:'',
      dateTime:'',
      slotCounter:{
        reserved:0,
        inLine:0,
        deleted:0,
        scanned:0
      },
      id:'',
      loader:false
    };
    this.intervalId = null;
    this.apiserve = new service();
  }

  componentDidMount() {
    this.getAllProductCouponList();
    this.getProductEditListdetails();
    this.intervalId = setInterval(this.getAllProductCouponList, 30000)
    this.setState({
      loaderFlag: true,
    });
  }

  componentWillUnmount(){
    clearInterval(this.intervalId);
    sub.unsubscribe();
  }

  onInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  getProductEditListdetails = () => {
    sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "admin|waitlistQueueStats":
          const allReservations = response.data?.waitListReservations || [];
          const byQueue = (a, b) => (a.queueNumber || 0) - (b.queueNumber || 0);

          // The API links a pair from the primary side (primary.companionId) and
          // leaves companion.primaryId null, so resolve the owner from both
          const ownerByCompanionId = {};
          allReservations.forEach(d => {
            if (d.companionId) ownerByCompanionId[d.companionId] = d._id;
          });
          const ids = new Set(allReservations.map(d => d._id));
          const ownerOf = (d) => {
            const owner = d.primaryId || ownerByCompanionId[d._id];
            return owner && ids.has(owner) ? owner : null;
          };

          const groups = {};
          allReservations.filter(d => !ownerOf(d)).sort(byQueue).forEach(d => { groups[d._id] = [d]; });
          allReservations.filter(d => ownerOf(d)).sort(byQueue).forEach(d => groups[ownerOf(d)].push(d));

          // Groups ordered by the primary's queue number, primary first in each group
          const sortedData = Object.values(groups)
            .sort((a, b) => byQueue(a[0], b[0]))
            .flat();
          this.setState(
            {
              waitListReservations:sortedData ,
              title:response.data.article ? response.data.article +' '+response.data.title : response.data.title ? response.data.title : response.data.name ,
              dateTime:response.data.dateTime,
              slotCounter:{reserved:response.data?.waitListReservations.filter(_ => _.status === WAITLIST_STATUS.RESERVED).length,inLine:(response.data?.waitListReservations.filter(_ => _.status === WAITLIST_STATUS.ADMITTED).length),deleted:response.data?.waitListReservations.filter(_ => _.status === WAITLIST_STATUS.DELETED).length, scanned:response.data?.waitListReservations.filter(_ => _.status === WAITLIST_STATUS.SCANNED).length}
            },
            () => {
              this.setState({
                loaderFlag: false,
                id:'',
                loader:false
              });
              this.addClass();
            }
          );
          break;
        case "waitList|updateMyWaitListStatus":
          this.getAllProductCouponList()
          break;
        case "waitList|unapproveWaitlist":
          this.getAllProductCouponList()
          break;
      }
    });
  };
 
  toggleCheckmark = (e,data) => {
    this.setState({loader:true, id:data._id})
    this.apiserve.sendevent("waitList|updateMyWaitListStatus", {"reservationId": data._id,"status": WAITLIST_STATUS.ADMITTED,userId:data.user.id});
  };

  unapproveWaitlist = (e,data) => {
    this.setState({loader:true, id:data._id})
    this.apiserve.sendevent("waitList|unapproveWaitlist", {"reservationId": data._id,userId:data.user.id});
  };

  toggleWaitlistPopup = (e, pass) => {
    this.setState({
      isWaitlistPopupOpen:true,
      passId:pass
    });
  };
  closeScanPopup = (e) => {
    this.setState({
      isWaitlistPopupOpen:false,
      passId:''
    });
  };

  getAllProductCouponList = () => {
    this.apiserve.sendevent("admin|waitlistQueueStats", {screeningEventiveId:this.props.match.params.screeningId});
  };

  addClass = (e) => {
    document.querySelectorAll('.sd_detail_pg > div').forEach(div => {
      if (div.nextElementSibling && div.nextElementSibling.classList.contains('sd_compaion_record')) {
        // Add a new class to the current div
        div.classList.add('sd_none_companion');
      }
    });
  }

  render() {
    const { getLastUpdated } = this.state;
    var updateAt = new Date(getLastUpdated && getLastUpdated.updatedAt);
    var hour = moment(updateAt).format("h");
    var minutes = moment(updateAt).format("mm");
    var state = moment(updateAt).format("A");
    var updatedBy = getLastUpdated && getLastUpdated.updatedBy;
    const { isClicked } = this.state;

    return (
      <React.Fragment>
        <div className="right_side_wrapper sd_waitlist_detail">
          <ul className="fpg_admin_tab disp_flex">
            {this.state.data &&
              this.state.data.map((list, index) => {
                return (
                  <li className="active">
                    <p className="uppercase text_left">
                      {list.label}
                      <Link to="create-film">
                        <PlusIcon />
                      </Link>
                    </p>
                  </li>
                );
              })}
          </ul>

          <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
            <Link className="back_link sd_desktop" to="/waitlist-management">
              {" "}
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
                <path d="M6.83264 15H11.0762L7.23136 11.0413C6.7472 10.5286 6.09216 9.95904 5.49408 9.41792C6.4624 9.4464 7.3168 9.4464 7.91488 9.4464H15.8893V6.37056H7.91488C7.3168 6.37056 6.49088 6.37056 5.49408 6.39904C6.12064 5.82944 6.7472 5.20288 7.28832 4.63328L11.0762 0.76H6.83264L0.16832 7.88L6.83264 15Z" fill="white"/>
              </svg>{" "}
              Back
              </Link>
              <div className="sd_waitlist_screening_detail">
                <div className="sd_waitlist_screening_film_detail">
                  <h5 className="common_waitlist_bold_text">Waitlist For: {this?.state?.title}</h5>
                  <p className="common_waitlist_normal_text">{this.state.dateTime.locations?.name} - {this.state.dateTime.locations?.city?.name} - {moment.tz(this.state.dateTime.date, "US/Mountain").format("h:mm A")} {moment.tz("America/Denver").format("z")}</p>
                </div>
                {this.state.dateTime.maxWaitListSlots === 0 && <p className="sd_zero_waitlist_slots">0 Waitlist slots</p>}
                <div className="sd_waitlist_screening_slot_detail sd_desktop">
                  <p><span className="common_waitlist_normal_text">Reserved :</span> <span className="common_waitlist_bold_text">{(this.state.slotCounter.reserved + this.state.slotCounter.inLine + this.state.slotCounter.scanned)}/{this.state.dateTime.maxWaitListSlots}({this.state.dateTime.maxWaitListSlots > 0 ? Math.round(((this.state.slotCounter.reserved + this.state.slotCounter.inLine)/this.state.dateTime.maxWaitListSlots)*100).toFixed(0) : 0}%)</span></p>
                  <p><span className="common_waitlist_normal_text">In Line :</span> <span className="common_waitlist_bold_text">{this.state.slotCounter.inLine}</span></p>
                  <p><span className="common_waitlist_normal_text">Scanned :</span> <span className="common_waitlist_bold_text">{this.state.slotCounter.scanned}</span></p>
                  <p><span className="common_waitlist_normal_text">Deleted :</span> <span className="common_waitlist_bold_text">{this.state.slotCounter.deleted}</span></p>
                </div>
              </div>
              <button className='sd_refresh_btn' onClick={() => this.getAllProductCouponList()}><WaitlistRefreshIcon/></button>
              <div className="sd_mobile">
                <Link className="back_link" to="/waitlist-management">
                  {" "}
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
                    <path d="M6.83264 15H11.0762L7.23136 11.0413C6.7472 10.5286 6.09216 9.95904 5.49408 9.41792C6.4624 9.4464 7.3168 9.4464 7.91488 9.4464H15.8893V6.37056H7.91488C7.3168 6.37056 6.49088 6.37056 5.49408 6.39904C6.12064 5.82944 6.7472 5.20288 7.28832 4.63328L11.0762 0.76H6.83264L0.16832 7.88L6.83264 15Z" fill="white"/>
                  </svg>{" "}
                  Back
                </Link>
                {this.state.dateTime.maxWaitListSlots === 0 && <p className="sd_zero_waitlist_slots">0 Waitlist slots</p>}
                <div className="sd_waitlist_screening_slot_detail">
                    <p><span className="common_waitlist_normal_text">Reserved :</span> <span className="common_waitlist_bold_text">{this.state.slotCounter.reserved}/{this.state.dateTime.maxWaitListSlots}({this.state.dateTime.maxWaitListSlots > 0 ? Math.round(((this.state.slotCounter.reserved)/this.state.dateTime.maxWaitListSlots)*100).toFixed(0) : 0}%)</span></p>
                    <p><span className="common_waitlist_normal_text">In Line :</span> <span className="common_waitlist_bold_text">{this.state.slotCounter.inLine}</span></p>
                    <p><span className="common_waitlist_normal_text">Deleted :</span> <span className="common_waitlist_bold_text">{this.state.slotCounter.deleted}</span></p>
                  </div>
              </div>
          </div>
          <div className="product_detail_content fpg_tabcontent sd_product_detail">
          <div className="sd_detail_pg">
                {this.state.waitListReservations && this.state.waitListReservations.length > 0 ? this.state.waitListReservations.map(item => (
                  <div className={`${item?.isCompanion ? 'sd_compaion_record' : ''} sd_detail_pg_item`} key={item._id}>
                  <li className={`${item.status}`}>
                      <div className="disp_flex d_flex_align_center d_flex_just_between">
                          <div className="disp_flex d_flex_align_center">
                            <div className="sd_que_num">
                                <span>{item.queueNumber}</span>
                            </div>
                            <div className="sd_name">
                                <h5 className="capitalize">{item?.isCompanion ? 'Companion' : item.user.display_name}</h5>
                                <p className="capitalize">pass: <span>{item.pass.type === "user_pass" ? 'User Pass' : 'Waitlist Badge'}</span></p>
                            </div>
                          </div>
                          <div className="sd_status">
                              <p className="capitalize">pass: <span>{item.pass.type === "user_pass" ? 'User Pass' : 'Waitlist Badge'}</span></p> |
                              <p className="capitalize">Status: <span>{item.status === WAITLIST_STATUS.ADMITTED ? 'In Line' : item.status}</span></p>
                          </div>
                          <div className="disp_flex d_flex_align_center d_flex_just_between">
                              <div className={`sd_checkmark ${item.status === WAITLIST_STATUS.ADMITTED ? 'isChecked' : item.status === WAITLIST_STATUS.SCANNED ? 'isScanned' : ''}`} onClick={(e) => item.status === WAITLIST_STATUS.RESERVED ? this.toggleCheckmark(e,item) : item.status === WAITLIST_STATUS.ADMITTED ? this.unapproveWaitlist(e, item) : ''}>
                                  {item.status === WAITLIST_STATUS.SCANNED ? <img src={checkmarkiconGreen} alt="checkmarkicon" /> : (item.status === WAITLIST_STATUS.RESERVED || item.status === WAITLIST_STATUS.ADMITTED) && this.state.loader && item._id === this.state.id ? <img src={this.apiserve.loader} alt="loader" style={{margin:'0 auto'}}/> : <img src={checkmarkicon} alt="checkmarkicon" />} 
                              </div>
                              <div className="sd_barcode">
                                  <button onClick={(e) => this.toggleWaitlistPopup(e,item.pass)}>
                                    <img src={Barcode} alt="barcode" width={34} height={34}/>
                                  </button>
                              </div>
                          </div>
                      </div>
                  </li>
                  </div>
                )) : <p className="sd_waitlist_notfound">There are currently no reservations for this screening.</p>}
              </div>
          </div>
        </div>
        {this.state.isWaitlistPopupOpen && (
          <div className='user_popup active sd_waitlist_sccan_popup'>
            <span className="popup_overlay" onClick={(e) => this.closeScanPopup(e)}></span>
            <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
                <p className="sd_close_popup" onClick={(e) => this.closeScanPopup(e)}><span></span><span></span></p>
                <div className="approve_popup_header text_center relative">
                    <WailtListQRCode width={'198px'} value={this.state.passId} />
                </div>
            </div>
        </div>
        )}
        {this.state.deleteFilm ? (
          <PopUpCustomAll
            HeaderName="Delete?"
            insideDetails="You are about to delete an item and this action is permanent"
            insideData="Do you want to proceed?"
            popupState={this.closeAdminUser}
            yesPopUp={this.deleteFilmPopupYes}
          />
        ) : (
            ""
          )}
        {this.state.publishFilm ? (
          <PopUpCustomAll
            HeaderName="Publish Changes"
            insideDetails="Saving the current changes will publish it to the production site"
            insideData="Do you want to proceed?"
            popupState={this.closeAdminUser}
            yesPopUp={this.publishFilmPopupYes}
          />
        ) : (
            ""
          )}
        {this.state.disableFilm ? (
          <PopUpCustomAll
            HeaderName="Disable?"
            insideDetails="You are about to disable an item, which will temporarily make it unavailable on the production site"
            insideData="Do you want to proceed?"
            popupState={this.closeAdminUser}
            yesPopUp={this.disableFilmPopupYes}
          />
        ) : (
            ""
          )}
        {this.state.discardPopup ? (
          <PopUpCustomAll
            HeaderName="Discard Changes?"
            insideDetails="Leaving this page without saving will discard all changes"
            insideData="Do you want to proceed?"
            popupState={this.closeAdminUser}
            yesPopUp={this.discardPopupYes}
          />
        ) : (
            ""
          )}
        <div className={`user_popup ${this.state.errorMsg ? "active" : ""}`}>
          <span className="popup_overlay"></span>
          <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
            <div className="approve_popup_header text_center relative">
              <p>{this.state.errorMsgShow}</p>
            </div>
            <div className="content">
              <div className="field_row text_center">
                <button
                  className="small_btn active"
                  onClick={this.validateModel}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
        {this.state.loaderFlag ? <Loader /> : ""}
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, null)(WaitlistListDetail);
